/**
 * Versione del testo privacy mostrato all'utente al momento del consenso (M5).
 * Il server la registra insieme al timestamp del consenso: va incrementata
 * ogni volta che il testo della normativa privacy cambia.
 */
export const PRIVACY_VERSION = '2026-11-01';
